const sticky = document.querySelector(".crumpler-header--sticky");
if (sticky) {
  sticky.closest(".shopify-section").classList.add("crumpler-header--sticky");
  sticky.classList.remove("crumpler-header--sticky");
}
document
  .querySelector(".crumpler-header__mobile-menu")
  .addEventListener("click", (e) => {
    e.target
      .closest(".crumpler-header__panel")
      .classList.toggle("crumpler-header__panel--mobile-menu-opened");
  });
document.querySelector(".crumpler-header").addEventListener("click", (e) => {
  if (
    e.target.closest(".crumpler-header__menu-link--has-menu") &&
    !e.target.closest(".crumpler-header__overlay")
  ) {
    // close other opened menus
    document
      .querySelectorAll(".crumpler-header__menu-link--has-menu")
      .forEach((el) => {
        el !== e.target.closest(".crumpler-header__menu-link--has-menu") &&
        el.classList.remove("crumpler-header__menu-link--opened");
      });
    e.target
      .closest(".crumpler-header__menu-link--has-menu")
      .classList.toggle("crumpler-header__menu-link--opened");
  }
  if (e.target.closest(".crumpler-header__overlay-close svg")) {
    e.target
      .closest(".crumpler-header__menu-link--has-menu")
      .classList.remove("crumpler-header__menu-link--opened");
  }
  let target;
  if (
    (target = e.target.closest(
      ".crumpler-header__page-content ul li:nth-child(odd)",
    ))
  ) {
    const alreadyOpened = target
      .closest(".crumpler-header__page-content")
      .querySelector(".crumpler-header__page-content--opened");

    alreadyOpened?.classList.remove("crumpler-header__page-content--opened");
    if (alreadyOpened !== target) {
      target.classList.add("crumpler-header__page-content--opened");
    }
  }
  if ((target = e.target.closest(".crumpler-header__mobile-menu"))) {
    target
      .closest(".crumpler-header")
      .classList.add("crumpler-header--mobile-menu-opened");
    // open the first menu in the mobile menu
    document
      .querySelector(
        ".crumpler-header__panel--has-mobile-menu .crumpler-header__menu-link--has-menu",
      )
      ?.classList.add("crumpler-header__menu-link--opened");
    e.stopPropagation();
  }
});
document.body.addEventListener("click", (e) => {
  // find any opened menu
  const openedMenu = document.querySelector(
    ".crumpler-header__menu-link--opened",
  );
  if (
    openedMenu &&
    !e.target.closest(".crumpler-header__menu-link--has-menu")
  ) {
    openedMenu.classList.remove("crumpler-header__menu-link--opened");
    e.stopPropagation();
  }
  // close the mobile menu
  if (
    e.target.closest(".crumpler-header__mobile-menu-close") ||
    !e.target.closest(".crumpler-header")
  ) {
    document
      .querySelector(".crumpler-header")
      .classList.remove("crumpler-header--mobile-menu-opened");
    e.stopPropagation();
  }
});
